// extracted by mini-css-extract-plugin
export default {"footer":"index_footer_SVt33","foot_link":"index_foot_link_OhOmw","list":"index_list_--JGk","link":"index_link_JhB1c","copyright":"index_copyright_37rWs"};